import React from 'react';
import type { PitruAcharyaProfile } from '../../data/pitruAcharyas';
import { acharyaDisclaimer } from './content';

const httpsUrl = (value?: string) => {
  try { return value && new URL(value).protocol === 'https:' ? value : undefined; }
  catch { return undefined; }
};
const photoUrl = (value: string) => /^\/(?!\/)[^\\]*$/.test(value) ? value : httpsUrl(value);

export default function AcharyaNetwork({ profiles }: { profiles: readonly PitruAcharyaProfile[] }) {
  const approved = profiles.filter(profile => profile.approved && profile.name.trim() && photoUrl(profile.photoUrl)
    && profile.biography.trim() && profile.location.trim() && profile.specializations.length > 0).slice(0, 3);
  if (!approved.length) return null;
  return <section className="pp-landing__section" aria-labelledby="pp-acharyas-title">
    <div className="pp-landing__wrap">
      <p className="pp-landing__eyebrow">People behind the arrangements</p>
      <h2 id="pp-acharyas-title">Meet some of the Acharyas in our network</h2>
      <p className="pp-landing__intro">{acharyaDisclaimer}</p>
      <div className="pp-landing__profiles">
        {approved.map(profile => <article className="pp-landing__profile" key={profile.id}>
          <img src={photoUrl(profile.photoUrl)} alt={profile.name} width={360} height={360} loading="lazy" />
          <div className="pp-landing__profile-body">
            <p className="pp-landing__eyebrow">{profile.location}</p>
            <h3>{profile.name}</h3>
            <p>{profile.biography}</p>
            <dl>
              <dt>Ritual specialization</dt><dd>{profile.specializations.join(' · ')}</dd>
              {profile.verifiedYearsOfExperience !== undefined && Number.isFinite(profile.verifiedYearsOfExperience) && profile.verifiedYearsOfExperience >= 0 &&
                <><dt>Experience</dt><dd>{profile.verifiedYearsOfExperience} years</dd></>}
              {!!profile.verifiedLanguages?.length && <><dt>Languages</dt><dd>{profile.verifiedLanguages.join(' · ')}</dd></>}
              {profile.verifiedTraining && <><dt>Training</dt><dd>{profile.verifiedTraining}</dd></>}
            </dl>
            {httpsUrl(profile.videoIntroductionUrl) && <a href={profile.videoIntroductionUrl} target="_blank" rel="noopener noreferrer">Watch {profile.name}’s introduction <span aria-hidden="true">↗</span></a>}
          </div>
        </article>)}
      </div>
    </div>
  </section>;
}
